import { useRef, useState } from 'react'

/**
 * Which ruler guides are selected (with a latest-value mirror for key handlers), and the last
 * shape selection that cleared it.
 */
export function useGuideSelection() {
  const [selectedGuideIds, setSelectedGuideIds] = useState<Set<string>>(new Set())
  const selectedGuideIdsRef = useRef(selectedGuideIds)

  selectedGuideIdsRef.current = selectedGuideIds

  /**
   * Last shape-selection set we used to clear ruler-guide selection. ShapeManager notifies
   * `onSelectionChange` from a `useEffect` on `selectedShapeIds`, which can run more than once
   * with the same ids (e.g. Strict Mode remount). Without deduping, the second run clears guide
   * selection right after ruler-drag creates a guide — labels only appear after the next drag.
   */
  const lastShapeSelectionClearKeyRef = useRef<string>('')

  return {
    selectedGuideIds,
    setSelectedGuideIds,
    selectedGuideIdsRef,
    lastShapeSelectionClearKeyRef,
  }
}
